import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserAttributes } from "slices/authSlice";
import JoiningEfficeDeets from "../ui/JoiningEfficeDeets";
import Avatar from "components/Home/ui/Avatar";
import { tryUseAnotherAccount } from "slices/joinSlice";
import { getPersonName } from "helpers/randomHelpers";

const QuickJoin = ({ inviteEffice, postConfirm }) => {
  const dispatch = useDispatch();
  const myAttributes = useSelector(selectCurrentUserAttributes);
  const [loading, setLoading] = useState(false);

  return (
    <div className="signInUpFormBox form-shadow">
      <JoiningEfficeDeets inviteEffice={inviteEffice} />
      <button
        onClick={async () => {
          setLoading(true);
          await postConfirm();
          setLoading(false);
        }}
        className={`confirm-button growth-button d-flex justify-content-center align-items-center ${
          loading ? "disabled" : ""
        }`}
      >
        <div className="join-as-avatar">
          <Avatar
            avatar_key={myAttributes.avatar_key}
            given_name={myAttributes.given_name}
            family_name={myAttributes.family_name}
          />
        </div>
        <span className="join-as-name">
          {`Join As `}
          {getPersonName(myAttributes.given_name, myAttributes.family_name)}
        </span>
      </button>
      <button
        onClick={() => dispatch(tryUseAnotherAccount())}
        className="forgotten-password"
      >
        use another account?
      </button>
    </div>
  );
};

export default QuickJoin;
